<mat-form-field appearance="outline" subscriptSizing="dynamic">
    <input matInput maxlength="100" placeholder="{{ 'search' | translate }}" #searchVal
        (change)='checkSearchVal(searchVal.value)' (keyup)="checkSearchVal(searchVal.value)"
        (keyup.enter)="checkSearchVal(searchVal.value)" />
    <mat-icon matPrefix class="op-5 inputTxt">
        <i-tabler name="search" class="icon-20 d-flex"></i-tabler>
    </mat-icon>
</mat-form-field>
